import { apiPost, type ApiResponse } from "@/lib/api";
import type { TreatBrief } from "@/lib/types";

export interface TreatWriteInput {
  subject: string;
  place: string;
  meet_time: string;
  limit_cnt: number;
  limit_min: number;
  memo?: string;
}

export interface TreatJoinResult {
  pick?: number;
  join_cnt?: number;
  left_cnt?: number;
  is_joined?: number;
  [key: string]: unknown;
}

// 등록 (오늘로 고정 — 날짜 파라미터 없음)
export function writeTreat(input: TreatWriteInput): Promise<ApiResponse<TreatBrief>> {
  return apiPost<TreatBrief>("treat_write.php", { act: "write", ...input });
}

// 주최자 조기 마감
export function closeTreat(no: number): Promise<ApiResponse<unknown>> {
  return apiPost<unknown>("treat_write.php", { act: "close", no });
}

// 주최자 삭제 (신청자 있으면 서버가 거절)
export function deleteTreat(no: number): Promise<ApiResponse<unknown>> {
  return apiPost<unknown>("treat_write.php", { act: "del", no });
}

// 신청
export function joinTreat(no: number): Promise<ApiResponse<TreatJoinResult>> {
  return apiPost<TreatJoinResult>("treat_join.php", { no });
}

// 신청 취소 (자리 반납)
export function cancelTreat(no: number): Promise<ApiResponse<TreatJoinResult>> {
  return apiPost<TreatJoinResult>("treat_join.php", { no, act: "cancel" });
}